import { render, staticRenderFns } from "./AddYear.vue?vue&type=template&id=18b65de0&"
import script from "./AddYear.vue?vue&type=script&lang=js&"
export * from "./AddYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports